require('jsoneditor/dist/jsoneditor.css');

var JSONEditor = require('jsoneditor/dist/jsoneditor.js');

var JsonEditorDirective = function ($timeout) {
    var defaults = {mode: 'tree'};

    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            'options': '='
        },
        link: function ($scope, element, attrs, ngModel) {
            var debounceTo, debounceFrom;
            var editor;
            var internalTrigger = false;

            function _createEditor(options) {
                var settings = angular.extend({}, defaults, options);
                var theOptions = angular.extend({}, settings, {
                    onChange: function () {
                        if (typeof debounceTo !== 'undefined') {
                            $timeout.cancel(debounceTo);
                        }

                        debounceTo = $timeout(function () {
                            if (editor) {
                                internalTrigger = true;
                                var error = undefined;
                                var data = editor.get();
                                try {
                                    ngModel.$setViewValue(data)
                                } catch (err) {
                                    error = err;
                                }

                                if (settings && settings.hasOwnProperty('onChange')) {
                                    settings.onChange(data, error);
                                }
                            }
                        }, settings.timeout || 100);
                    }
                });

                element.html('');

                var instance = new JSONEditor(element[0], theOptions);

                if ($scope.ngJsoneditor instanceof Function) {
                    $timeout(function () {
                        $scope.ngJsoneditor(instance);
                    });
                }

                return instance;
            }

            $scope.$watch('options', function (newValue, oldValue) {
                for (var k in newValue) {
                    if (newValue.hasOwnProperty(k)) {
                        var v = newValue[k];

                        if (newValue[k] !== oldValue[k]) {
                            if (k === 'mode') {
                                editor.setMode(v);
                            } else if (k === 'name') {
                                editor.setName(v);
                            } else { //other settings cannot be changed without re-creating the JsonEditor
                                editor = _createEditor(newValue);
                                $scope.updateJsonEditor();
                                return;
                            }
                        }
                    }
                }
            }, true);

            $scope.$on('$destroy', function () {
                //remove jsoneditor?
            });

            $scope.updateJsonEditor = function (newValue) {
                if (internalTrigger) {
                    //ignore if called by $setViewValue (after debounceTo)
                    internalTrigger = false;
                    return;
                }

                if (typeof debounceFrom !== 'undefined') {
                    $timeout.cancel(debounceFrom);
                }

                debounceFrom = $timeout(function () {
                    editor.set(ngModel.$viewValue === undefined ?{} : ngModel.$viewValue);
                }, $scope.options.timeout || 100);
            };

            editor = _createEditor($scope.options);

            if ($scope.options.hasOwnProperty('expanded')) {
                $timeout($scope.options.expanded
                    ? function () {
                        editor.expandAll()
                    }
                    : function () {
                        editor.collapseAll()
                    }, ($scope.options.timeout || 100) + 100);
            }

            ngModel.$render = $scope.updateJsonEditor;
            $scope.$watch(function () {
                return ngModel.$modelValue;
            }, $scope.updateJsonEditor, true);
        }
    }
};
JsonEditorDirective.$injector = ['$timeout'];


var json_editor_component = {
    bindings: {
        options: "<",
        model: "<",
        onChange: "&"
    },
    template: "<button ng-click='$ctrl.onChange({model: $ctrl.model})'>Test Components</button>",
    controller: ['$timeout' , function ($timeout) {
        this.$onInit = function () {
            //
        };
        this.$onChanges = function (changesObj) {
            if (changesObj.model) {
                //
            }
            if (changesObj.options) {

            }

        };
    }]
}

export default function (app) {
    app.directive('amtJsonEditor', JsonEditorDirective);
    app.component('amtJsonEditorComponents', json_editor_component)
};
